<template>
  <div>
    <b-table v-if="!isLoading" :fields="fields" :items="items" head-variant="light" hover responsive>
      <template v-slot:cell(identifier)="linha">
        {{ linha.item.identifier }}
        <p class="m-0 small" v-if="linha.item.athlete_id">
          {{ linha.item.athlete_id }}
        </p>
      </template>
      <template v-slot:cell(vns_name)="linha">
        <p class="m-0 small" v-if="linha.item.vns_name">
                    <span class="font-weight-bold">
                        {{ $t('ordemResultado.table.fields.vns') }}:</span> {{ linha.item.vns_name }}
        </p>
        <p class="m-0 small" v-if="linha.item.company_name">
                    <span class="font-weight-bold">
                        {{ $t('ordemResultado.table.fields.empresa') }}:</span> {{ linha.item.company_name }}
        </p>
      </template>
      <template v-slot:cell(status)="linha">
        <span :class="{'badge rounded-pill': true, 'badge-success': linha.item.in_vs}"
              v-b-tooltip.hover
              :title="$t('ordemResultado.table.status.ordem_recebida')"
        ><i class="fas fa-laptop-code"/></span>
        <span :class="{'badge rounded-pill': true, 'badge-success': linha.item.has_report}"
              v-b-tooltip.hover
              :title="$t('ordemResultado.table.status.resultados')"
        ><i class="fas fa-file-medical-alt"/></span>
        <span :class="{'badge rounded-pill': true, 'badge-danger': linha.item.has_mapping_error}"
              v-b-tooltip.hover
              :title="$t('ordemResultado.table.status.erro_dexpara')"
        ><i class="fas fa-exclamation-triangle"/></span>
        <span :class="{'badge rounded-pill': true, 'badge-danger': linha.item.has_support_error}"
              v-b-tooltip.hover
              :title="$t('ordemResultado.table.status.erro_suporte')"
        ><i class="fas fa-ban"/></span>
      </template>
      <template v-slot:cell(last_update)="linha">
        {{ linha.item.last_update| formatDate }}
      </template>
      <template v-slot:cell(acoes)="linha">
        <b-btn variant="outline-primary border-0" pill
               @click="$emit('click-recipient', linha.item)">
          <i class="fas fa-vial"/></b-btn>
      </template>
    </b-table>
    <Loading v-else/>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import moment from "moment";

export default {
  name: "Table",
  components: {
    Loading,
    moment
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    additionalFields: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        {
          key: 'identifier',
          label: this.$t('ordemResultado.table.fields.recipiente')
        },
        {
          key: 'vns_name',
          label: this.$t('ordemResultado.table.fields.informacoes')
        },
        {
          key: 'patient_name',
          label: this.$t('ordemResultado.table.fields.paciente')
        },
        {
          key: 'last_update',
          label: this.$t('ordemResultado.table.fields.ultima_atualizacao')
        },
        {
          key: 'status',
          label: 'Status'
        },
        {
          key: 'acoes',
          label: this.$t('ordemResultado.table.fields.acoes')
        }
      ]
    }
  },
  methods: {
    getLastUpdate(container) {
      let maxOrderDate = null
      let maxReportDate = null
      container.orders.map(order => {
        const received_at = moment(order.received_at)
        const collected_at = moment(order.collected_at)
        const created_at = moment(order.created_at)

        maxOrderDate = this.getMaxDate([maxOrderDate, received_at, collected_at, created_at])
      })
      container.reports.map(report => {
        const processed_at = moment(report.processed_at)
        const created_at = moment(report.created_at)

        maxReportDate = this.getMaxDate([processed_at, created_at])
      })

      return this.getMaxDate([maxOrderDate, maxReportDate])
    },
    getMaxDate(arrayDates) {
      let maxDate = null
      arrayDates.map(date => {
        if (date && date.isValid()) {
          if (!maxDate) {
            maxDate = date
          }
          if (date.diff(maxDate) > 0) {
            maxDate = date
          }
        }
      })
      return maxDate
    }
  },
  mounted() {
    this.fields = [...this.fields, ...this.additionalFields]
  }
}
</script>

<style lang="scss" scoped>
.badge {
  color: #dddfeb;
  padding: 0.40em;

  i {
    font-size: 1.5em;
  }
}

.badge-danger {
  background-color: #ffe1de;
  color: #e74a3b;
}

.badge-success {
  background-color: #d8fbee;
  color: #1cc88a;
}
</style>
